import { MIN_TRANSITION_DURATION } from 'constant'
import * as ActionTypes from '../ActionTypes'

export const patchAudioTransition = (asset, patch, options, dispatch) => {
  let patchTransition = { ...patch }
  if ('fadeInDuration' in patch) {
    patchTransition = { ...patchTransition, fadeInIsActive: true }
    if (asset.fadeOutIsActive) {
      patchTransition.fadeInDuration = Math.max(0,
        Math.min(asset.duration - asset.fadeOutDuration, patch.fadeInDuration))
      if (!patchTransition.fadeInDuration) {
        patchTransition = {
          fadeInIsActive: false,
        }
      }
    } else {
      patchTransition.fadeInDuration = Math.max(MIN_TRANSITION_DURATION,
        Math.min(asset.duration, patch.fadeInDuration))
    }
  }
  if ('fadeOutDuration' in patch) {
    patchTransition = { ...patchTransition, fadeOutIsActive: true }
    if (asset.fadeInIsActive) {
      patchTransition.fadeOutDuration = Math.max(0,
        Math.min(asset.duration - asset.fadeInDuration, patch.fadeOutDuration))
      if (!patchTransition.fadeOutDuration) {
        patchTransition = {
          fadeOutIsActive: false,
        }
      }
    } else {
      patchTransition.fadeOutDuration = Math.max(MIN_TRANSITION_DURATION,
        Math.min(asset.duration, patch.fadeOutDuration))
    }
  }
  dispatch({
    type: ActionTypes.ASSET_SETTINGS_FORM_UPDATED,
    payload: { id: asset.id, asset, patch: patchTransition, options },
  })
}
